module.exports = __webpack_public_path__ + "static/media/tachometer.0df4fa15.svg";